module.exports = __webpack_public_path__ + "img/b2.8ab70bb1.png";